import Component from './AnalyticsPeriodPicker.vue'
export default Component
